import React from 'react';
import './confirm-delete-modal.css';

export default function ConfirmDeleteModal({
  open,
  title = 'Confirm Deletion',
  message,
  warning,
  confirmLabel = 'Yes, Delete',
  cancelLabel = 'Cancel',
  loading = false,
  canConfirm = true,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="admin-delete-modal">
      <div className="admin-delete-modal__panel" role="dialog" aria-modal="true">
        <h3 className="admin-delete-modal__title">{title}</h3>
        <p className="admin-delete-modal__message">
          {message}
          {warning ? <span className="admin-delete-modal__warning">{warning}</span> : null}
        </p>
        <div className="admin-delete-modal__actions">
          {canConfirm && (
            <button
              type="button"
              className="admin-delete-modal__btn admin-delete-modal__btn--danger"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? (
                <span className="admin-delete-modal__spinner" aria-hidden="true" />
              ) : (
                confirmLabel
              )}
            </button>
          )}
          <button
            type="button"
            className="admin-delete-modal__btn admin-delete-modal__btn--cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
